import React from 'react'
import { render } from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import App from './components/App/App'
import castApp from './reducers'

// create store, set initial state
const store = createStore(castApp,
 { layers: {
     organizations: {
       id: "organizations",
       visible: true
     }
   },
   section: 'arts'
  })

// Log the initial state
/*
console.log(store.getState())
*/
// Every time the state changes, log it
// Note that subscribe() returns a function for unregistering the listener
/*
let unsubscribe = store.subscribe(() =>
  console.log(store.getState())
)
*/


render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js